import { QueryClient } from "@tanstack/react-query";

/**
 * One client for the whole app, so every screen's `useQuery` shares the same
 * cache — navigate away from a screen and back, and it renders from what is
 * already held here before the background refetch below even starts.
 *
 * Defaults left mostly as TanStack Query ships them, which already are the
 * behaviour this app wants: `staleTime: 0` means a mount always shows cached
 * data first and revalidates quietly behind it rather than blocking on a
 * spinner, and the default `gcTime` (5 minutes) is how long an unmounted
 * screen's data survives to be reused as that instant first paint.
 *
 * `retry: false` is the one default overridden. Every screen already draws a
 * `"failed"` state with its own retry button, and the library's default of
 * three attempts with backoff would sit on that spinner for several seconds
 * before ever reaching it — worse than the old behaviour, not better.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});
